import React, { Component } from 'react';
import axios from 'axios';
import intl from 'react-intl-universal';
import imgfLoading from '../../assets/img/preloader-black.gif';

class DatabaseBeingCreated extends Component {
  constructor(oProps) {
    super(oProps);

    document.body.classList.add('w-bkg');

    this.state = {
      bRedirectScheduled: false
    };
  }

  componentDidMount = () => {
    this.schedulePolling();
  };

  componentDidUpdate = oPreviousProps => {
    if (oPreviousProps.cProvisioningToken !== this.props.cProvisioningToken) {
      this.schedulePolling();
    }

    if (this.props.cStatus === 'completed' && !this.state.bRedirectScheduled) {
      this.setState({ bRedirectScheduled: true });
      this.stopPolling();
      window.setTimeout(() => {
        window.location.href = '/login';
      }, 1500);
    }

    if (this.props.cStatus === 'failed') {
      this.stopPolling();
    }
  };

  componentWillUnmount = () => {
    this.stopPolling();
  };

  /**
   * Agenda consultas leves enquanto o backend prepara a base. O intervalo e
   * iniciado somente apos o cadastro entregar a credencial temporaria.
   */
  schedulePolling = () => {
    const { cProvisioningToken } = this.props;
    if (!cProvisioningToken || this.nPollingInterval) {
      return;
    }

    this.fetchProvisioningStatus();
    this.nPollingInterval = window.setInterval(this.fetchProvisioningStatus, 5000);
  };

  stopPolling = () => {
    if (this.nPollingInterval) {
      window.clearInterval(this.nPollingInterval);
      this.nPollingInterval = null;
    }
  };

  /**
   * Consulta o estado sem autenticar nem criar sessao. Em falha de rede, o
   * proximo intervalo tenta novamente para evitar uma tela travada por erro transitorio.
   */
  fetchProvisioningStatus = () => {
    const { cProvisioningToken, onStatusChange } = this.props;
    if (!cProvisioningToken) {
      return;
    }

    axios
      .post('/customer/provisioning/status', { cProvisioningToken })
      .then(oResponse => onStatusChange(oResponse.data))
      .catch(oError => {
        if (oError.response) {
          const cError = oError.response.data?.cError || intl.get('erro_500');
          onStatusChange({ status: 'failed', failed: true, message: cError, modules: {} });
          return;
        }

        onStatusChange({
          status: 'running',
          failed: false,
          message: intl.get('DatabaseBeingCreated.connection_error'),
          modules: {}
        });
      });
  };

  render() {
    const { cError, cMessage, cStatus, aModules } = this.props;
    const bCompleted = cStatus === 'completed';
    const aModuleEntries = Object.entries(aModules || {});
    return (
      <section className="box-creating-database">
        <h1>{intl.get('DatabaseBeingCreated.quase_pronto')}</h1>

        {cError ? (
          <p className="notice backup-notice" role="alert">{cError}</p>
        ) : (
          <>
            <p className="notice backup-notice">{cMessage || intl.get('DatabaseBeingCreated.criando_banco')}</p>
            {aModuleEntries.length > 0 && (
              <ul className="provisioning-progress" aria-live="polite">
                {aModuleEntries.map(([cModule, oModule]) => (
                  <li key={cModule}>
                    <span>{intl.get(`DatabaseBeingCreated.modules.${cModule}`)}</span>
                    <span>
                      {intl.get(`DatabaseBeingCreated.status.${oModule.status || 'pending'}`)}
                      {typeof oModule.processed === 'number' && typeof oModule.total === 'number'
                        ? ` (${oModule.processed}/${oModule.total})`
                        : ''}
                    </span>
                  </li>
                ))}
              </ul>
            )}
            {!bCompleted && <img src={imgfLoading} alt="" />}
          </>
        )}
      </section>
    );
  }
}

export default DatabaseBeingCreated;
